import React from "react";
import Modal from "react-modal";
import { GlobalNetwork } from "../Networks";
import { HrefCTA, ButtonCTA, FlexCenter } from "../Utils";
import ResearchImg from "../../Images/Experience/Alumni/min-research.jpg";
import HandshakeImg from "../../Images/business-desk.jpg";
import AlumniImg from "../../Images/Experience/Alumni/min-presentation.jpg";
import ResourcesImg from "../../Images/Experience/Alumni/min-alumni-resources.jpg";


const Alumnis = [
  {
    name: "Alumni",
    subText: "",
    url: "/alumni",
    banner: {
      big: AlumniImg
    },
    internal: true,
  },
  {
    name: "Calls for partnerships",
    subText: "",
    url: "/calls-for-partnership",
    banner: {
      big: HandshakeImg
    },
    internal: true,
  },
  {
    name: "Resources",
    subText: "",
    url: "/resources",
    banner: {
      big: ResourcesImg
    },
    internal: true,
  },
  {
    name: "Global projects",
    subText: "",
    url: "/global-projects",
    banner: {
      big: ResearchImg
    },
    internal: true,
  },
];

const cardTheme = {
  textAlign: "center",
  height: "280px",
  maxHeight: "300px",
  backColor: "transparent",
  boxShadow: "none",
  borderRadius: "0.25rem",
  borderTop: "6px solid hsl(217, 53%, 17%)",
  textHoverColor: "hsl(0, 0%, 16%)",
};

export default function Alumni () {
  return (
    <div style={{marginBottom: "20px"}}>
      <GlobalNetwork
      title="Alumni Corner"
      minCardWidth="200px"
      maxCardWidth="1fr"
      cardGap="24px"
      cardBodyPad="15px 1.5px 5px"
      bgColor="hsl(0,0%,96%)"
      cards={Alumnis}
      theme={cardTheme}
      />
      
    </div>
  );
}

function GlobalProjectModal({isModalOpen, handleModalOpen}) {
  return (
    <Modal
      isOpen={isModalOpen}
      contentLabel="Global Projects & Resources"
      onRequestClose={handleModalOpen}
      closeTimeoutMS={2000}
      className="alumni__modal"
    >
    <h3 className="modal__title">Global projects & Resources</h3>
    <div>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
      <FlexCenter className="mt-5">
        <HrefCTA 
          href="https://lms.globalgers.co/tiki-index.php" 
          rel="noopener noreferrer"
          target="_blank"
          className="mr-1"
        >
          Login
        </HrefCTA>
        <ButtonCTA
          color="#333"
          bgColor="hsl(0,3.1%,87.5%)"
          hoverBgColor="hsl(0,3.1%,92%)"
          hoverBorderColor="hsl(0,3.1%,92%)"
          onClick={handleModalOpen}
          className="ml-1"
        >
          Cancel
        </ButtonCTA>
      </FlexCenter>
      
      
    </div>
  </Modal>
  )

}

// haveButton={<HrefCTA 
//   bgColor="hsl(217,40%,40%)"
//   hoverBgColor="hsl(217,40%,30%)"
//   hoverBorderColor="transparent"
//   href="https://lms.globalgers.co/tiki-index.php" 
//   rel="noopener noreferrer"
//   onClick={() => alert('yett')}>
//   Login
// </HrefCTA>
// }
export { GlobalProjectModal }



// WEBPACK FOOTER //
// ./src/Components/Experiences/Alumni.js